import { z } from "zod";
import { DTOPageBlockDefinition } from "../../dto/documentation/block-definition";

//
// Read
//

export const DTOGetBlockDefinitionsQuery = z.object({
  files: z.coerce.boolean().optional(),
});

export const DTOGetBlockDefinitionsOutput = z.object({
  definitions: z.array(DTOPageBlockDefinition),
});

export type DTOGetBlockDefinitionsOutput = z.infer<typeof DTOGetBlockDefinitionsOutput>;
export type DTOGetBlockDefinitionsQuery = z.infer<typeof DTOGetBlockDefinitionsQuery>;
